<!--
  - Copyright (c) 2023-2024. Haodong JU
  -->

<template>
  <div>
    <template v-if="!storageReady">
      <no-product-page />
    </template>
    <div
      v-else
      class="mt-4"
    >
      <template v-if="isActive">
        <v-tabs
          v-model="tab"
          background-color="transparent"
          color="black"
          style="background: transparent"
        >
          <v-tab>{{ $t('ProductAndMaterialRelation') }}</v-tab>
          <v-tab>{{ $t('PropertiesOfRawMaterialRelationships') }}</v-tab>
          <v-tab>{{ $t('rawEdit') }}</v-tab>
          <v-tab>{{ $t('inventoryLog') }}</v-tab>
          <v-tab>{{ $t('inventoryConsume') }}</v-tab>
        </v-tabs>
        <v-divider />
        <loading-provider :loading="loading">
          <v-tabs-items
            v-model="tab"
            class="mt-4"
            style="background: transparent"
          >
            <v-tab-item>
              <dish-relation-page />
            </v-tab-item>
            <v-tab-item>
              <attr-relation-page />
            </v-tab-item>
            <v-tab-item>
              <resource-page />
            </v-tab-item>
            <v-tab-item>
              <change-log-page />
            </v-tab-item>
            <v-tab-item>
              <inventory-consume />
            </v-tab-item>
          </v-tabs-items>
        </loading-provider>
      </template>
      <template v-else>
        <div
          class="d-flex align-center justify-center flex-column"
          style="height: 80vh"
        >
          <div>
            <v-icon size="48">
              mdi-alert-circle-outline
            </v-icon>
          </div>
          <div class="text-h4 mt-6">
            {{ $t('FunctionNotActiv') }}
          </div>
          <div class="text-body-1 mt-2 text--secondary">
            {{ $t('PleaseActivateProduct') }}
          </div>
          <v-btn
            class="mt-4"
            color="amber lighten-4 black--text"
            elevation="0"
            width="10%"
            @click="activeDialog = true"
          >
            {{ $t('Opened') }}
          </v-btn>
        </div>
      </template>
    </div>
    <v-dialog
      v-model="activeDialog"
      max-width="500px"
      persistent
    >
      <base-form
        :schema="schemas"
        @close="activeDialog=false"
        @submit="saveUserInfo"
      >
        <div>{{ $t('OpenInventory') }}</div>
        <template #subtitle>
          {{ $t('OpenInventorySubtitle') }}
        </template>
      </base-form>
    </v-dialog>
  </div>
</template>

<script>
import DishRelationPage from '@/views/AadenPages/extraModules/storage/DishRelationPage.vue'
import { getActiveProductCode } from '@/model/dataLayer/api/SaaS/user'
import { ProductCodes } from '@/model/dataLayer/api/SaaS/product'
import NoProductPage from '@/views/widget/commonLogic/NoProductPage'
import AttrRelationPage from '@/views/AadenPages/extraModules/storage/AttrRelationPage.vue'
import LoadingProvider from '@/views/widget/LoadingProvider.vue'
import { checkStorageStatus, openStorage } from '@/model/dataLayer/api/storage/inventoryUtils'
import BaseForm from '@/views/widget/INK/BaseForm/BaseForm'
import { VSwitch } from 'vuetify/lib/components'
import ResourcePage from '@/views/AadenPages/extraModules/storage/ResourcePage'
import ChangeLogPage from '@/views/AadenPages/billAndReport/ChangeLogPage.vue'
import InventoryConsume from '@/views/AadenPages/extraModules/storage/InventoryConsume.vue'

export default {
  name: 'PersonalInfoPage',
  components: {
    InventoryConsume,
    ChangeLogPage,
    ResourcePage,
    BaseForm,
    LoadingProvider,
    AttrRelationPage,
    NoProductPage,
    DishRelationPage
  },
  data () {
    return {
      activeDialog: false,
      tab: null,
      storageReady: false,
      loading: false,
      isActive: false
    }
  },
  watch: {
    tab () {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 100)
    }
  },
  computed: {
    schemas () {
      return [
        {
          key: 'name',
          name: 'Name'
        },
        {
          key: 'addressLine1',
          name: 'AddressLine1'
        },
        {
          key: 'addressLine2',
          name: 'AddressLine2'
        },
        {
          key: 'inventoryPeriodDays',
          name: 'InventoryPeriodDays'
        },
        {
          key: 'bossPassword',
          name: 'BossPassword'
        },
        {
          key: 'taxNumber',
          name: 'taxNumber'
        },
        {
          key: 'city',
          name: 'city'
        },
        {
          key: 'legalName',
          name: 'CompanyName'
        },
        {
          key: 'postalCode',
          name: 'plzArea'
        },
        {
          key: 'country',
          name: 'Country'
        },
        {
          key: 'telephone',
          name: 'telephone'
        },
        {
          key: 'iban',
          name: 'iban'
        },
        {
          key: 'bic',
          name: 'bic'
        },
        {
          key: 'bankName',
          name: 'BankName'
        },
        {
          key: 'deliveryBillEnding',
          name: 'DeliveryBillEnding'
        },
        {
          key: 'billEnding',
          name: 'BillEnding'
        },
        {
          key: 'enableReport',
          name: 'DailyReport',
          hint: 'DailyReportHint',
          component: VSwitch,
          default: true
        },
        {
          key: 'enableSales',
          name: 'DailyItemSales',
          hint: 'DailyItemSalesHint',
          component: VSwitch,
          default: true
        }
      ]
    }
  },
  async mounted () {
    try {
      const storeStatus = await checkStorageStatus()
      if (storeStatus) {
        this.isActive = true
      }
    } catch (e) {
      console.log(e, 'e')
    }
    try {
      const res = await getActiveProductCode()
      this.storageReady = res.includes(ProductCodes.inventory)
    } catch (e) {

    }
  },
  methods: {
    async saveUserInfo (info) {
      console.log(info, 'info')
      await openStorage(info)
      this.activeDialog = false
      this.isActive = true
    }
  }
}
</script>

<style scoped>
.text-slate-500 {
  --tw-text-opacity: 1;
  color: rgb(100 116 139 / var(--tw-text-opacity));
}

.text-slate-600 {
  --tw-text-opacity: 1;
  color: rgb(71 85 105 / var(--tw-text-opacity));
}
</style>
